module.exports = __webpack_public_path__ + "media/images/groupRank__eval--correct@3x-257d52867f1e1c98578c4350138dea0c.png";